export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./card-course.vue?vue&type=template&id=4d048df9&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/card-course/card-course.vue?vue&type=template&id=4d048df9&
// module id = 1485
// module chunks = 0